import { useCallback, useState } from 'react';
import { useRegisterPhysicalCard as useRegisterPhysicalCardMutation } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';
import * as Sentry from '@sentry/react';

/* Hook */
export const useRegisterPhysicalCard = () => {
  const id = useAuthStore((store) => store.id);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  /* Mutations */
  const registerPhysicalCard = useRegisterPhysicalCardMutation({
    onError: (error: any) => {
      console.log(
        `Register physical card: Unexpected error - ${error.message}`,
      );
      setError(error?.response?.data?.msg);
    },
    onSuccess: () => {
      console.log('Register physical card: Successfully registered');
    },
  });

  /* Callbacks */
  const handleRegisterPhysicalCard = useCallback(
    async (
      cardTypeId: number,
      cardNumber: string,
      tierId?: number,
      amount?: number,
    ) => {
      if (!cardNumber || !id) return;
      setIsLoading(true);
      setError(undefined);
      try {
        const result = await registerPhysicalCard.mutateAsync({
          userId: id,
          cardTypeId,
          cardNumber,
          ...(tierId !== undefined && { tierId }),
          ...(amount !== undefined && { amount }),
        });
        return result;
      } catch (error: any) {
        const errorMessage = error?.response?.data?.msg;
        console.error('Failed to register physical card:', errorMessage);
        setError(errorMessage);
        Sentry.captureException({
          message: 'Failed to register physical card',
          extra: { error },
        });
        throw new Error(`Failed to register physical card: ${errorMessage}`);
      } finally {
        setIsLoading(false);
      }
    },
    [id, registerPhysicalCard],
  );

  /* Return */
  return {
    handleRegisterPhysicalCard,
    isLoading,
    error,
  };
};
